import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ENetworkFlag } from '../../../model/application/ENetworkFlag';
import { SyncDmsService } from '../services/syncDms.service';
import { IDmsTaskParams } from 'apps/idl/src/model/backgroundTask';
import { FlagService, InjectorService } from 'apps/idl/src/services/security';
import { TaskBase, TaskDescriptor } from 'apps/idl/src/services/security/backgroundTask';

export class SyncDmsTask<T extends IDmsTaskParams> extends TaskBase<T> {

	//#region FIELDS

	private msvcSyncDms: SyncDmsService;
	/** Service permettant de manipuler les flags. */
	private msvcFlag: FlagService;

	//#endregion

	//#region METHODS

	constructor(poDescriptor: TaskDescriptor<T>) {
		super(poDescriptor);
		this.msvcSyncDms = InjectorService.instance.get(SyncDmsService);
		this.msvcFlag = InjectorService.instance.get(FlagService);
	}

	public execTask(): Observable<Array<string>> {
		return this.msvcFlag.waitForFlag(ENetworkFlag.isOnlineReliable, true)
			.pipe(mergeMap(_ => this.msvcSyncDms.syncPendingChanges(true)));
	}

	//#endregion
}